<template>
  <div class="dispatch-role-menu">
    <div class="toolbar">
      <span class="hint">勾选该角色可访问的左侧菜单</span>
      <a-button type="primary" :loading="saving" @click="save">保存</a-button>
    </div>
    <a-spin :spinning="loading">
      <a-checkbox-group v-model="checkedIds" class="menu-list">
        <label v-for="item in menuList" :key="item.id" class="menu-item">
          <a-checkbox :value="item.id">
            <a-icon :type="item.icon || 'menu'" />
            <span>{{ item.name }}</span>
          </a-checkbox>
        </label>
      </a-checkbox-group>
      <a-empty v-if="!loading && !menuList.length" description="请先在数据库执行 24_dispatch_sys_menu.sql" />
    </a-spin>
  </div>
</template>

<script>
import { dispatchApi } from "./dispatchApi";

export default {
  name: "DispatchRoleMenuTree",
  props: {
    roleId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      menuList: [],
      checkedIds: [],
      loading: false,
      saving: false,
    };
  },
  watch: {
    roleId: {
      immediate: true,
      handler() {
        this.load();
      },
    },
  },
  methods: {
    async load() {
      if (!this.roleId) return;
      this.loading = true;
      try {
        const [menus, assigned] = await Promise.all([
          dispatchApi.listDispatchMenus(),
          dispatchApi.listDispatchRoleMenu(this.roleId),
        ]);
        this.menuList = menus || [];
        this.checkedIds = (assigned || []).map((m) => m.id);
      } catch (e) {
        this.$message.error((e && e.message) || "加载菜单失败");
        this.menuList = [];
        this.checkedIds = [];
      } finally {
        this.loading = false;
      }
    },
    async save() {
      this.saving = true;
      try {
        await dispatchApi.saveDispatchRoleMenu(this.roleId, this.checkedIds);
        this.$message.success("菜单权限已保存");
      } catch (e) {
        this.$message.error((e && e.message) || "保存失败");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style scoped>
.dispatch-role-menu {
  display: flex;
  flex-direction: column;
  min-height: 320px;
}

.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.hint {
  color: #64748b;
  font-size: 13px;
}

.menu-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.menu-item {
  display: block;
  padding: 10px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
}

.menu-item:hover {
  border-color: #0082d4;
  background: #f8fafc;
}

.menu-item >>> .ant-checkbox-wrapper {
  width: 100%;
}

.menu-item span {
  margin-left: 8px;
}
</style>
